import { Form, message } from "antd";
import BaseModalForm from "components/BaseModalForm";
import Vocabulary, { getVocabulary } from "components/Vocabulary";
import moment from "moment";
import React, { forwardRef } from "react";
import ExceptionAPI from "restAPI/ExceptionAPI";
import { FieldTypes } from "utils/formUtils";

const ExtendApproveByDateModal = forwardRef(function ExtendApproveByDateModal(
  { editId, afterClose },
  ref,
) {
  const [form] = Form.useForm();
  const fields = [
    {
      name: "newApproveByDate",
      label: "Approve By Date",
      type: FieldTypes.DATE,
      required: true,
      colSpan: 12,
      props: {
        style: { width: "100%" },
      },
    },
    {
      name: "comment",
      label: "Comment",
      type: FieldTypes.TEXT_AREA,
      required: true,
    },
  ];
  const onSubmit = async (data) => {
    data.newApproveByDate = moment(data.newApproveByDate).utc().format();
    await ExceptionAPI.extendExceptionApproveByEndDate(data, editId).promise;
    message.success(
      `Successfully extended approve by date for ${getVocabulary("exception")}`,
    );
  };
  return (
    <>
      <BaseModalForm
        modalProps={{ okText: "Save" }}
        form={form}
        title={
          <>
            Extend <Vocabulary name="exception" /> Approve By Date
          </>
        }
        onOk={onSubmit}
        ref={ref}
        fields={fields}
        afterClose={afterClose}
      />
    </>
  );
});

export default ExtendApproveByDateModal;
